module.exports = __webpack_public_path__ + "static/img/thumb_9.3ea2f0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_9.jpg
// module id = Kqpq
// module chunks = 0